import { ApiClient } from "@common/services/ApiClient"

export default new ApiClient("core-api")
